"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.default=void 0;var _default={isType(identifier){return"string"===identifier}};exports.default=_default;
